var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-switch",class:Object.assign({}, _vm.$attrs.class,
    {'is-checked': _vm.value})},[_c('div',{staticClass:"foreground"}),_c('input',_vm._g(_vm._b({attrs:{"type":"checkbox"},domProps:{"checked":_vm.value}},'input',_vm.$attrs,false),_vm.$listeners))])}
var staticRenderFns = []

export { render, staticRenderFns }